import { render, staticRenderFns } from "./GeneralStatusDropdown.vue?vue&type=template&id=46c57a97&scoped=true&"
import script from "./GeneralStatusDropdown.vue?vue&type=script&lang=js&"
export * from "./GeneralStatusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c57a97",
  null
  
)

export default component.exports